<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app fixed class="pt-11" width="259px">
      <v-app-bar
        color="white"
        dark
        fixed
        flat
        style="margin-top: 43px; height: 105px; width: 255px"
      >
        <div>
          <router-link
            style="text-decoration: none; color: black; line-height: 1"
            to="/"
          >
            <v-row>
              <v-col
                cols="4"
                style="
                  padding-top: 54px;
                  padding-left: 30px;
                  margin-left: -20px;
                "
              >
                <v-img
                  src="../src/assets/depsec.png"
                  height="80"
                  contain
                ></v-img>
              </v-col>
              <v-col
                cols="8"
                style="padding-top: 54px; margin-left: -5px; max-width: 140px"
              >
                <span class="subtitle-2">DEPSEC</span>
                <br />
                <span class="caption"
                  >Departamento de Processos Seletivos e Concursos</span
                >
              </v-col>
            </v-row>
          </router-link>
        </div>
      </v-app-bar>

      <div>
        <v-list shaped dense v-if="isStaff || isAdmin" class="mt-16 pt-10">
          <v-list-group v-if="isAdmin">
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Painel Administrativo</v-list-item-title>
            </template>
            <v-list-item-group>
              <v-list-item link :to="`/processos/`">
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  Gerência de Editais</v-list-item-title
                >
              </v-list-item>
              <v-list-item link :to="`/cursos/`">
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  Gerência de Cursos</v-list-item-title
                >
              </v-list-item>
              <v-list-item link :to="`/usuarios/`">
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  Gerência de Usuários</v-list-item-title
                >
              </v-list-item>
              <v-list-item link :to="`/usuarios-admin/`">
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  Gerência de Usuários Institucionais</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-list-group v-if="isAuthenticated && cops_ps.length > 0">
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Sou Organizador</v-list-item-title>
            </template>
            <v-list-item-group>
              <v-list-item
                v-for="(link, index) in cops_ps"
                :key="index"
                link
                :to="`/processos/${link._id}`"
                class="my-1"
              >
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  {{ link.title }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
          <v-list-group v-if="isAuthenticated && board_ps.length > 0">
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Sou Avaliador</v-list-item-title>
            </template>
            <v-list-item-group>
              <v-list-item
                v-for="(link, index) in board_ps"
                :key="index"
                link
                :to="`/processos/${link._id}`"
                class="my-1"
              >
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                >
                  {{ link.title }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
        </v-list>

        <v-list
          shaped
          dense
          expand
          v-if="!isAdmin && !isStaff"
          class="mt-16 pt-10"
        >
          <v-list-group
            small
            :value="meusConcursos.length > 0"
            v-if="isAuthenticated"
          >
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Meus Concursos</v-list-item-title>
            </template>
            <v-list-item-group
              :mandatory="my_list_mandatory"
              v-model="my_list"
              ref="list_item"
            >
              <v-list-item
                link
                v-for="(link, index) in meusConcursos"
                :key="index"
                @click="goToPs(link.to, 'my')"
                class="my-1"
              >
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                  >{{ link.title }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-list-group :value="true">
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Concursos em Andamento</v-list-item-title>
            </template>

            <v-list-item-group>
              <v-list-item
                link
                v-for="(link, index) in concursos"
                :key="index"
                @click="goToPs(link.to, 'general')"
                class="my-1"
              >
                <v-list-item-icon class="ml-n1">
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="ml-n7"
                  style="
                    white-space: initial;
                    text-align: left;
                    list-style-type: square;
                  "
                  >{{ link.title }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-list-group :value="false">
            <template v-slot:appendIcon>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-title>Concursos Encerrados</v-list-item-title>
            </template>
            <v-list-group
              sub-group
              class="ml-n3"
              :value="false"
              v-for="(link, index) in concursosEncerrados"
              :key="index"
            >
              <template v-slot:prependIcon>
                <v-icon> mdi-triangle-small-down</v-icon>
              </template>
              <template v-slot:activator>
                <v-list-item-title>{{ link.ano }}</v-list-item-title>
              </template>
              <v-list-item-group>
                <v-list-item
                  link
                  v-for="(ps, index) in link.pss"
                  :key="index"
                  @click="goToPs(ps.to, 'general')"
                  class="my-1"
                >
                  <v-list-item-icon class="">
                    <v-icon>mdi-circle-small</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    class="ml-n3"
                    style="
                      white-space: initial;
                      text-align: left;
                      list-style-type: square;
                    "
                  >
                    {{ ps.title }}</v-list-item-title
                  >
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list-group>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      color="primary"
      dark
      dense
      elevation="0"
      fixed
      app
      style="margin-top: 41px"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-row
        justify="end"
        :class="$vuetify.breakpoint.mobile ? 'pt-0' : 'mb-n2'"
      >
        <v-btn
          @click="goTo('/entrar')"
          v-if="!isAuthenticated"
          depressed
          color="primary"
        >
          <span class="text-capitalize">Entrar</span>
        </v-btn>

        <div v-show="$vuetify.breakpoint.xs" v-if="isAuthenticated">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-n2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-avatar color="blue darken-4" size="26" class="mr-2"
                  >{{
                    user.usar_nome_social ? user.social_name[0] : user.name[0]
                  }}{{
                    user.usar_nome_social
                      ? user.social_name.split(" ")[
                          user.social_name.split(" ").length - 1
                        ][0]
                      : user.name.split(" ")[user.name.split(" ").length - 1][0]
                  }}</v-avatar
                >
                <span class="text-capitalize">{{
                  user.usar_nome_social
                    ? user.social_name.split(" ")[0] +
                      " " +
                      user.social_name.split(" ")[
                        user.social_name.split(" ").length - 1
                      ]
                    : user.name.split(" ")[0] +
                      " " +
                      user.name.split(" ")[user.name.split(" ").length - 1]
                }}</span>
                <v-icon style="margin-left: 5px" dark>
                  mdi-triangle-small-down
                </v-icon>
              </v-btn>
            </template>
            <v-list color="primary" class="text-right align-self-start">
              <v-list-item-title
                v-for="(item, index) in createButtonsList"
                :key="index"
              >
                <v-btn
                  v-if="returnPermission(item.permission) && index !== 0"
                  depressed
                  color="primary"
                  @click="() => call(item.method)"
                >
                  <span class="text-capitalize">{{ item.title }}</span>
                </v-btn>
              </v-list-item-title>
            </v-list>
          </v-menu>
        </div>

        <div
          class="hidden-xs-only pt-1"
          v-for="(item, index) in createButtonsList"
          :key="index"
        >
          <v-btn
            v-if="isAuthenticated && index === 0"
            depressed
            color="primary"
          >
            <v-avatar color="blue darken-4" size="32" class="mr-2"
              >{{ user.usar_nome_social ? user.social_name[0] : user.name[0]
              }}{{
                user.usar_nome_social
                  ? user.social_name.split(" ")[
                      user.social_name.split(" ").length - 1
                    ][0]
                  : user.name.split(" ")[user.name.split(" ").length - 1][0]
              }}</v-avatar
            >
            <span class="text-capitalize">{{
              user.usar_nome_social
                ? user.social_name.split(" ")[0] +
                  " " +
                  user.social_name.split(" ")[
                    user.social_name.split(" ").length - 1
                  ]
                : user.name.split(" ")[0] +
                  " " +
                  user.name.split(" ")[user.name.split(" ").length - 1]
            }}</span>
          </v-btn>
          <v-btn
            v-else-if="returnPermission(item.permission)"
            depressed
            color="primary"
            @click="() => call(item.method)"
          >
            <span class="text-capitalize">{{ item.title }}</span>
          </v-btn>
        </div>
      </v-row>
    </v-app-bar>

    <LoadingDialog :loading="loading" />
    <CalendarDialog
      v-if="calendar"
      :dialog="calendar"
      @close="calendar = false"
    />

    <v-main>
      <v-container fluid class="pa-2 pt-12">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath"> </router-view>
        </transition>
      </v-container>
    </v-main>

    <v-footer fixed app>
      <v-row
        justify="center"
        no-gutters
        class="text-caption font-weight-medium"
      >
        <div>
          {{ new Date().getFullYear() }} - Curso de Ciência da Computação -
          DEPSEC - UNIFAP
        </div>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import auth from "@/services/auth_handler";
import { app } from "./services/feathers";
import LoadingDialog from "@/components/LoadingDialog.vue";
import CalendarDialog from "@/components/CalendarDialog.vue";
import { compileExpression } from "filtrex";

export default {
  metaInfo: {
    title: "UNIFAP",
    // all titles will be injected into this template
    titleTemplate: "%s - DEPSEC",
  },
  components: { LoadingDialog, CalendarDialog },
  name: "App",

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isAdmin", "isStaff"]),
    ...mapGetters("concursos", [
      "concursos",
      "meusConcursos",
      "concursosEncerrados",
    ]),
    ...mapState("auth", ["token", "user"]),
    currentRoute: function () {
      return this.$route.path;
    },
    createButtonsList() {
      let buttonsList = [
        {
          title: "Nome",
          icon: "mdi-account-circle",
          permission: "isAuthenticated",
        },
        {
          title: "Calendário",
          method: "opensCalendarDialog",
          permission: "exists(id) and (staff or admin)",
        },
        {
          title: "Atualizar dados",
          method: "goToToAtualizarConta",
          permission: "exists(user) and exists(id) and not staff and not admin",
        },
        {
          title: "Alterar Senha",
          method: "goToToAlterarSenha",
          permission:
            "exists(user) and exists(id) and (not staff and not admin)",
        },
        {
          title: "Alterar Senha",
          method: "goToToAlterarSenhaAdmin",
          permission: "exists(user) and exists(id) and (staff or admin)",
        },
        {
          title: "Sair",
          method: "goToSair",
          permission: "exists(user) and exists(id)",
        },
      ];
      return buttonsList;
    },
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    "links.length": function (newVal, oldVal) {
      const indexMenu = this.links.findIndex((x) => x.to === this.currentRoute);
      if (indexMenu >= 0) {
        this.list = indexMenu;
      }
    },
    // eslint-disable-next-line no-unused-vars
    isAuthenticated: async function (status) {
      if (status) {
        this.getMyPs();
      } else {
        this.my_ps = [];
      }
    },
  },

  async created() {
    this.loading = true;
    await this.fetchConcursos();
    await this.getMyPs();
    this.loading = false;
  },

  data: () => ({
    calendar: false,
    loading: false,
    drawer: true,
    my_list: "",
    my_list_mandatory: false,
    list: "",
    list_mandatory: true,
    cops_ps: [],
    board_ps: [],
    linksClosed: [],
  }),
  methods: {
    ...mapActions("concursos", ["fetchConcursos"]),
    returnPermission(item) {
      let myfilter = compileExpression(item);

      let permission = myfilter({
        isAuthenticated: this.isAuthenticated,
        user: this.user,
        id: this.user._id,
        staff: this.isStaff,
        admin: this.isAdmin === undefined ? false : this.isAdmin,
      });

      return permission;
    },
    opensCalendarDialog() {
      this.calendar = true;
    },
    goToToAtualizarConta() {
      this.goTo("/atualizar-conta");
    },
    goToToAlterarSenha() {
      this.goTo("/alterar-login");
    },
    goToToAlterarSenhaAdmin() {
      this.goTo("/alterar-senha");
    },
    goToSair() {
      this.goTo("/sair");
    },
    call(method) {
      this[method]();
    },
    async getMyPs() {
      if (this.isStaff) {
        // captura os ps que eles sao delegados
        const my_boards = await app.service("selective-processes").find({
          query: {
            boardmembers: { $in: [this.user._id] },
            $sort: {
              createdAt: -1,
            },
          },
        });
        let my_boards_subprocess = await app
          .service("selective-processes")
          .find({
            query: {
              "subprocesses.boardmembers": { $in: [this.user._id] },
              $sort: {
                createdAt: -1,
              },
            },
          });

        const my_boards_subprocess2 = await app
          .service("selective-processes")
          .find({
            query: {
              "subprocesses.courses.banca": { $in: [this.user._id] },
              $sort: {
                createdAt: -1,
              },
            },
          });
        my_boards_subprocess.push(...my_boards_subprocess2);

        my_boards_subprocess = my_boards_subprocess.sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });

        const my_cops = await app.service("selective-processes").find({
          query: {
            cops: { $in: [this.user._id] },
            $sort: {
              createdAt: -1,
            },
          },
        });
        const my_cops_subprocess = await app
          .service("selective-processes")
          .find({
            query: {
              "subprocesses.cops": { $in: [this.user._id] },
              $sort: {
                createdAt: -1,
              },
            },
          });
        this.cops_ps = [...my_cops, ...my_cops_subprocess];
        this.board_ps = [...my_boards, ...my_boards_subprocess];
      }
    },
    goToPs(route, sidebar) {
      if (sidebar === "general") {
        this.list_mandatory = true;
        this.my_list_mandatory = false;
        this.my_list = "";
      } else {
        this.my_list_mandatory = true;
        this.list_mandatory = false;
        this.list = "";
      }
      const currentRoute = this.$router.currentRoute.path;

      if (route === "/sair") {
        this.board_ps = [];
        this.cops_ps = [];
        auth.logout();
      } else if (
        route === "/entrar" &&
        this.$router.currentRoute.name !== "Entrar"
      ) {
        this.$router.push({
          name: "Entrar",
          params: {
            next: "",
          },
        });
      } else if (currentRoute !== route) {
        this.$router.push(route).catch(() => {});
      }
    },
    goTo(route) {
      const currentRoute = this.$router.currentRoute.path;
      if (
        route === "/sair" ||
        route === "/entrar" ||
        route === "/nova-conta" ||
        route === "/atualizar-conta"
      ) {
        this.list_mandatory = false;
        this.list = "";
      } else {
        this.list_mandatory = true;
      }
      if (route === "/sair") {
        auth.logout();
      } else if (
        route === "/entrar" &&
        this.$router.currentRoute.name !== "Entrar"
      ) {
        this.$router.push({
          name: "Entrar",
          params: {
            next: "",
          },
        });
      } else if (currentRoute !== route) {
        this.$router.push(route).catch(() => {});
      }
    },
  },
};
</script>
<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.v-main {
  background-color: #e4e5e8;
}

.row-pointer >>> tbody tr:hover {
  cursor: pointer;
}

fieldset {
  border: 1px lightgray solid;
  border-radius: 5px;
}

.mx-input {
  height: 40px !important;
  width: 100% !important;
  font-size: 16px !important;
  border-color: #999999 !important;
  color: black !important;
}

.date-error .mx-input {
  border-color: red !important;
  border-width: 2px !important;
  color: red !important;
}

.date-error .mx-icon-calendar {
  color: red !important;
}

.toolbar-title-mobile {
  font-size: 1rem !important;
}
</style>
